import { useMemo } from "react";
import {
  buildDetailModel,
  buildSummaryRowModel,
} from "../utils/recordMappers";

export const useDataViewDerived = ({
  records,
  selectedRowIds,
  activeConfig,
  activeDataset,
  selectedRecordId,
  detailRecord,
  submittedQuery,
}) => {
  const selectedSummaryRecord = useMemo(
    () => records.find((record) => record._record_id === selectedRecordId) || null,
    [records, selectedRecordId]
  );

  const detailSourceRecord =
    activeDataset === "company" ? detailRecord : detailRecord || selectedSummaryRecord;
  const isSearchMode = Boolean(submittedQuery);

  const rowModels = useMemo(
    () => records.map((record) => buildSummaryRowModel(record, activeConfig)),
    [records, activeConfig]
  );

  const selectedRows = useMemo(
    () => records.filter((record) => selectedRowIds.includes(record._record_id)),
    [records, selectedRowIds]
  );

  const detailModel = useMemo(
    () => buildDetailModel(detailSourceRecord, activeConfig),
    [detailSourceRecord, activeConfig]
  );

  return {
    selectedSummaryRecord,
    detailSourceRecord,
    isSearchMode,
    rowModels,
    selectedRows,
    detailModel,
  };
};
